module.exports = {"410308002":"西霞院街道","410308003":"康乐街道","410308004":"吉利街道","410308005":"河阳街道","410308100":"城关镇","410308101":"会盟镇","410308102":"平乐镇","410308103":"送庄镇","410308104":"白鹤镇","410308105":"朝阳镇","410308106":"小浪底镇","410308107":"麻屯镇","410308108":"横水镇","410308109":"常袋镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410308.json
// module id = 1663
// module chunks = 0